module.exports = __webpack_public_path__ + "img/imagen1.e14248b9.png";